import { ProgressBar } from '@deque/cauldron-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '~/common/contexts/auth';
import useAICreditBalance from '../../hooks/useAICreditBalance';
import styles from './AICreditBalance.css';

const AICreditBalance: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const user = useAuthContext().user!; // Must be logged in to see this page.
  const { data, error, loading } = useAICreditBalance(user.token);
  const { t } = useTranslation();

  let content: React.ReactNode;
  if (loading) {
    // TODO: We want a proper <Loader> here. See https://github.com/dequelabs/axe-extension/issues/6750.
    content = (
      <p className={styles.loading}>{t('Loading AI credit balance...')}</p>
    );
  } else if (error) {
    content = (
      <p className={styles.error}>
        {t('An error occurred while loading AI credit balance')}
      </p>
    );
  } else if (data) {
    const balance = data.metric_value;
    const limit = data.limits[0].limit_value;
    const progress = Math.min((balance / limit) * 100, 100);
    const rnd = Math.random().toString(36).substring(2, 9);
    const id = `ai-credit-balance-${rnd}`;
    content = (
      <div className={styles.balance}>
        <strong id={id}>
          {t('{{ balance }} of {{ limit }} monthly AI credits used', {
            balance: balance.toLocaleString(),
            limit: limit.toLocaleString()
          })}
        </strong>
        <ProgressBar progress={progress} aria-labelledby={id} />
      </div>
    );
  } else {
    throw new Error('unreachable');
  }

  return (
    <div className={styles.container} data-testid="ai-credit-balance">
      {content}
    </div>
  );
};

export default AICreditBalance;
